import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { useDrawer } from "../providers";
import styles from "../Drawer.module.scss";
export const DrawerBody = ({ children, ...restProps }) => {
    const { isOpen } = useDrawer();
    return (_jsx("div", { className: classnames(styles.drawerBody, {
            [styles.isOpen]: isOpen,
        }), "data-testid": "drawer-body", ...restProps, children: children }));
};
DrawerBody.displayName = "DrawerBody";
//# sourceMappingURL=DrawerBody.js.map